import { Action, configureStore } from '@reduxjs/toolkit';

import boldPenguinReducer, { BoldPenguinQuotationState } from './components/bold-penguin-quotation/store/reducers';
import ncRoamSubsReducer, { NCRoamSubscriptionState } from './components/nc-roam-subscription/store/reducers';
import reminderNotificationsReducer, { ReminderNotificationsPopupState } from './components/reminder-notification-popup/store/reducers';
import userActivityEventsReducer, { UserActivityEventsState } from './components/user-activity-events/store/reducers';

import webSocketReducer, { WebSocketState } from './shared/store/reducers/web-socket';
import supportChatReducer, { SupportChatState } from './components/support-chat/store/reducer';

import globalTelecomReducer, { GlobalTelecomState } from './components/smses/store/reducers/global-telecom';
import ringCentralReducer, { RingCentralState } from './components/smses/store/reducers/ring-central';
import smsChatReducer, { SmsChatState } from './components/smses/store/reducers/sms-chat';
import smsSettingReducer, { SmsSettingState } from './components/smses/store/reducers/sms-setting';
import smsesReducer, { SMSesState } from './components/smses/store/reducers/smses';
import spokeReducer, { SpokeState } from './components/smses/store/reducers/spoke';
import twilioReducer, { TwilioState } from './components/smses/store/reducers/twilio';
import rabbitSignReducer, { RabbitSignState } from './components/rabbit-sign/store/reducers';
import signatureReducer, { SignatureState } from './components/signature/store/reducers';
import systemMessageEditReducer, { SystemMessageEditState } from './components/system-messages/store/reducers';
import notesReducer, { NotesState } from './components/notes/store/reducers/notes';
import noteTypesReducer, { NoteTypesState } from './components/notes/store/reducers/types';

import sharedReducer, { SharedState } from './shared/store/reducers/shared';

export const store = configureStore({
  reducer: {
    ncRoamSubs: ncRoamSubsReducer,
    boldPenguin: boldPenguinReducer,
    userActivityEvents: userActivityEventsReducer,
    reminderNotificationsForUser: reminderNotificationsReducer,

    webSocket: webSocketReducer,

    smses: smsesReducer,
    spoke: spokeReducer,
    globalTelecom: globalTelecomReducer,
    smsChat: smsChatReducer,
    smsSetting: smsSettingReducer,
    twilio: twilioReducer,
    ringCentral: ringCentralReducer,

    shared: sharedReducer,

    supportChat: supportChatReducer,
    rabbitSign: rabbitSignReducer,
    signature: signatureReducer,

    systemMessageEdit: systemMessageEditReducer,
    
    notes: notesReducer,
    noteTypes: noteTypesReducer,
  },
});

export type RootState = {
  ncRoamSubs: NCRoamSubscriptionState;
  boldPenguin: BoldPenguinQuotationState;
  userActivityEvents: UserActivityEventsState;
  reminderNotificationsForUser: ReminderNotificationsPopupState;

  webSocket: WebSocketState;

  smses: SMSesState;
  spoke: SpokeState;
  globalTelecom: GlobalTelecomState;
  smsChat: SmsChatState;
  smsSetting: SmsSettingState;
  twilio: TwilioState;
  ringCentral: RingCentralState;

  shared: SharedState;

  supportChat: SupportChatState;
  rabbitSign: RabbitSignState;
  signature: SignatureState;

  systemMessageEdit: SystemMessageEditState;
  
  notes: NotesState;
  noteTypes: NoteTypesState;
};
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export interface AppAction<T> extends Action {
  type: string;
  data: T | null | undefined;
  error: any | null | undefined;
}
